function getOS() {
  const ua = navigator.userAgent;
  const platform = navigator.platform || '';

  const os = {
    name: 'unknown',
    version: null,
    isWindows: /Win/i.test(platform),
    isMac: /Mac/i.test(platform),
    isLinux: /Linux/i.test(platform) && !/Android/i.test(ua),
    isAndroid: /Android/i.test(ua),
    isIOS: /iPhone|iPad|iPod/i.test(ua),
  };

  os.isMobile = os.isAndroid || os.isIOS;
  os.isDesktop = !os.isMobile;

  if (os.isWindows) {
    os.name = 'Windows';
    const match = ua.match(/Windows NT (\d+\.\d+)/);
    if (match) {
      const v = parseFloat(match[1]);
      os.version =
        v >= 10
          ? '10/11'
          : v === 6.3
            ? '8.1'
            : v === 6.2
              ? '8'
              : v === 6.1
                ? '7'
                : null;
    }
  } else if (os.isMac) {
    os.name = 'macOS';
    const match = ua.match(/Mac OS X (\d+)[._](\d+)/);
    if (match) os.version = `${match[1]}.${match[2]}`;
  } else if (os.isLinux) {
    os.name = 'Linux';
  } else if (os.isAndroid) {
    os.name = 'Android';
    const match = ua.match(/Android ([\d.]+)/);
    if (match) os.version = match[1];
  } else if (os.isIOS) {
    os.name = 'iOS';
    const match = ua.match(/OS (\d+)[._](\d+)/);
    if (match) os.version = `${match[1]}.${match[2]}`;
  }

  return os;
}

const os = getOS();
